<script>
  import Header from "./Header.vue";
  import Footer from "./Footer.vue";

  export default {
    components: {
      Header,
      Footer,
    },

    props: {
      title: {
        type: String,
        default: "",
      },
      primaryBtnText: {
        required: false,
        type: String,
        default: "confirm",
      },
      secondaryBtnText: {
        required: false,
        type: String,
        default: "cancel",
      },
      isPrimaryBtnDisabled: {
        type: Boolean,
        default: false,
      },
      isSubmitting: {
        required: false,
        default: false,
        type: Boolean,
      },
      actionsStatus: {
        type: Object,
        default: () => ({
          close: "enabled",
          primary: "enabled",
          cancel: "enabled",
        }),
        validator: (value) => Object.keys(value).every((key) => ["close", "primary", "cancel"].includes(key))
          && Object.values(value).every((key) => ["enabled", "loading", "disabled"].includes(key)),
      },
      width: {
        required: false,
        default: "500px",
        type: String,
      },
      paddingClasses: {
        type: String,
        required: false,
        default: "p-x-18 p-y-24",
      },
      hasFooter: {
        required: false,
        default: true,
        type: Boolean,
      },
      isPositionedElementOpened: {
        default: false,
        type: Boolean,
      },
    },

    data() {
      return {};
    },

    computed: {
      actionsStatusValue() {
        if (this.isSubmitting) {
          return {
            cancel: "disabled",
            close: "disabled",
            primary: "disabled",
          };
        }
        return this.actionsStatus;
      },
    },

    methods: {
      cancel() {
        this.$emit("cancel");
      },
      confirm() {
        this.$emit("primary-action");
      },
    },
  };
</script>
<template>
  <div id="modal-container" class="d-flex align-items-center justify-content-center modal-container">
    <div
      class="bg-base-white shadow-1 radius-8 p-y-12 d-flex flex-column justify-content-between modal-body"
      :style="{ width, maxWidth: width }"
    >
      <slot name="header">
        <Header
          :title="title"
          :close-btn-status="actionsStatusValue['close']"
          @cancel="cancel"
        >
          <template #header-title>
            <slot name="header-title" />
          </template>
        </Header>
      </slot>
      <div
        class="bg-neutral-100 modal-body primary-scroll"
        :class="[
          hasFooter ? paddingClasses : '',
          isPositionedElementOpened ? 'overflow-y-unset' : 'overflow-y-scroll',
        ]"
      >
        <slot />
      </div>
      <slot v-if="hasFooter" name="footer">
        <Footer
          :primary-btn-text="primaryBtnText"
          :secondary-btn-text="secondaryBtnText"
          :actions-status="actionsStatusValue"
          @confirm="confirm"
          @cancel="cancel"
        />
      </slot>
    </div>
  </div>
</template>
<style scoped lang='sass'>
.modal-container
  width: 100%
  height: 100vh
  position: fixed
  top: 0
  bottom: 0
  right: 0
  left: 0
  z-index: 10
  background: var(--base-white-05)

.modal-body
  max-height: 70vh
  @media (max-width: 470px)
    width: 95vw !important
</style>
